/** Global middleware: Applies authentication and legacy redirect checks */
import { useMiddlewareAuth } from '@composables/middleware/authenticated.hook'
import { useMiddlewareAutoLogin } from '@composables/middleware/auto-login.hook'

import { defineNuxtRouteMiddleware } from '#app'

// FIXME: auth.ts
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/dev/preview')) {
    return
  }

  const signature = (to.query?.signature as string | undefined) ?? undefined

  if (signature) {
    const autoLoginTarget = await useMiddlewareAutoLogin(to, signature)
    if (autoLoginTarget) return navigateTo(autoLoginTarget, { replace: true })
    return
  }

  const authResult = await useMiddlewareAuth(to)
  if (authResult) return authResult
})
